var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyticsOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.39792 20.15V20.1604H5.40833H9.67288H9.68329V20.15V11.7V11.6896H9.67288H5.40833H5.39792V11.7V20.15ZM11.0708 20.15V20.1604H11.0812H15.3355H15.3459V20.15V5.84998V5.83957H15.3355H11.0812H11.0708V5.84998V20.15ZM16.7334 20.15V20.1604H16.7438H21.0083H21.0188V20.15V13.65V13.6396H21.0083H16.7438H16.7334V13.65V20.15ZM9.6661 10.3021H9.67652V10.2917V6.18338C9.67652 5.70715 9.84577 5.29975 10.1845 4.96062L10.1772 4.95325L10.1845 4.96061C10.5231 4.62149 10.9304 4.45207 11.407 4.45207H14.9975C15.4741 4.45207 15.8818 4.62149 16.2213 4.96062C16.5608 5.29976 16.7304 5.70715 16.7304 6.18338V12.2417V12.2521H16.7408H20.6749C21.1512 12.2521 21.5586 12.4215 21.8977 12.7606C22.2368 13.0998 22.4063 13.5071 22.4063 13.9834V19.8166C22.4063 20.2928 22.2367 20.7002 21.8974 21.0393C21.5581 21.3785 21.1505 21.5479 20.6741 21.5479H5.73388C5.25747 21.5479 4.85135 21.3785 4.51494 21.0394C4.1785 20.7003 4.01042 20.2928 4.01042 19.8166V12.0334C4.01042 11.5571 4.17966 11.1497 4.51843 10.8106C4.85702 10.4715 5.26379 10.3021 5.73929 10.3021H9.6661Z",
    fill: "#6A6A6A",
    stroke: "#6A6A6A",
    strokeWidth: 0.0208333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsOutline);
export default __webpack_public_path__ + "static/media/analytics_outline.53374c822e0680d327168d116ad44748.svg";
export { ForwardRef as ReactComponent };